import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { AdCounter, CounterContainer, CounterNumber } from "./NumberCounter.styled";

export const NumberCounter = ({ currentIdx, total, isSingle }) => {
  const { t } = useTranslation();
  const [displayValue, setDisplayValue] = useState(currentIdx);
  const [isAnimating, setIsAnimating] = useState(false);
  const [animationDirection, setAnimationDirection] = useState("in");

  useEffect(() => {
    if (currentIdx !== displayValue) {
      setIsAnimating(true);
      setAnimationDirection("out");

      setTimeout(() => {
        setDisplayValue(currentIdx);
        setAnimationDirection("in");

        setTimeout(() => {
          setIsAnimating(false);
        }, 150);
      }, 150);
    }
  }, [currentIdx, displayValue]);

  return (
    <AdCounter $isSingle={isSingle}>
      <CounterContainer $isSingle={isSingle}>
        <CounterNumber $isAnimating={isAnimating} $direction={animationDirection}>
          {!displayValue || displayValue < 1 ? 1 : displayValue}
        </CounterNumber>
      </CounterContainer>
      {` ${t("of")} ${total}`}
    </AdCounter>
  );
};
